module.exports = __webpack_public_path__ + "static/media/main_logo.6644ba22.svg";